/* 言語切り替え */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import jaTranslation from './locales/ja/translation.json';
import enTranslationSe from './locales/en/translationSe.json';
import jaTranslationSe from './locales/ja/translationSe.json';
var is_se = document.getElementById('is-se');
var resources = {
    en: {
        translation: is_se.dataset.value ? enTranslationSe : enTranslation,
    },
    ja: {
        translation: is_se.dataset.value ? jaTranslationSe : jaTranslation,
    },
};
i18n.use(initReactI18next).init({
    resources: resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
        escapeValue: false,
    },
});
